import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { switchMap } from 'rxjs';
import { CardResource } from 'src/app/interfaces/card-resouce';
import { BasedatareportService } from 'src/app/services/basedatareport.service';
import { CardService } from 'src/app/services/card.service';

@Component({
  selector: 'app-card-files',
  templateUrl: './card-files.component.html',
  styleUrl: './card-files.component.scss'
})
export class CardFilesComponent {

  dataSource: MatTableDataSource<any>;
  displayedColumns = ['number', 'type', 'name', 'size', 'date', 'menu'];

  finishedLoading: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private cardService: CardService,
    private basedatareportService: BasedatareportService) {
    this.route.params.pipe(
      switchMap(params => { return this.cardService.getCard(params['id']) }),
      switchMap((card: CardResource) => { return this.cardService.getCardFiles(card.ownerPublicId) })
    ).subscribe((data: any) => {
      this.finishedLoading = true;
      this.dataSource = new MatTableDataSource(data.producedFiles)
    })
  }

  saveFile(file) {
    this.basedatareportService.downloadReport(file.name).subscribe((reportFile) => {
      const contentType = 'application/octet-stream';
      const blob = new Blob([reportFile], { type: contentType });
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      a.href = objectUrl;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl)
    })
  }


}
